module.exports = __webpack_public_path__ + "02_long_brown.a6c85c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_long_brown.png
// module id = jf/r
// module chunks = 0